import { jsx as _jsx } from "react/jsx-runtime";
const Reset = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M2.67001 3.99999L5.00001 1.66999L4.29001 0.959991L0.76001 4.49999L4.30001 8.03999L5.01001 7.32999L2.68001 4.99999H10.01C12.22 4.99999 14.01 6.78999 14.01 8.99999C14.01 11.21 12.22 13 10.01 13H5.00001V14H10C12.76 14 15 11.76 15 8.99999C15 6.23999 12.76 3.99999 10 3.99999H2.67001Z" }) })));
Reset.iconName = "reset";
Reset.iconCategory = "Arrows";
export default Reset;
